// @ts-expect-error Untyped
import { toggleInitialMessageBubble } from './toggleInitialMessageBubble';
// @ts-expect-error Untyped
import { trackUserInteraction } from '../../actions/trackUserInteraction';
import { handleClosedWelcomeMessage } from '../../post-message/handleClosedWelcomeMessage';
export const closeInitialMessageBubble = () => dispatch => {
  handleClosedWelcomeMessage();
  dispatch(toggleInitialMessageBubble(false, true));
  dispatch(trackUserInteraction());
};